module.exports = __webpack_public_path__ + "img/airplane.00905887.svg";